module.exports = __webpack_public_path__ + "static/media/news-14.28e4068c.jpg";